<script lang="ts" setup>
import { ref } from 'vue'

import {
  Coordinates,
  getMouseEventCoordinates,
} from '@collector/shared-ui-domain'
import BallPosition from '@desktop/views/Relation/Sports/components/RelationView/Main/PitchWithIncidents/PitchWithChangePossession/BallPosition/BallPosition.vue'

interface Props {
  ballSrc: string
}

defineProps<Props>()

// state
const coordinates = ref<Coordinates | null>()
const containerElement = ref<HTMLDivElement>()

// methods
function setCoordinatesFromMouseEvent(event: MouseEvent): void {
  coordinates.value = getMouseEventCoordinates(event, containerElement.value!)
}

function clearCoordinates(): void {
  coordinates.value = null
}
</script>

<template>
  <div
    ref="containerElement"
    class="absolute h-full w-full"
    @mousemove="setCoordinatesFromMouseEvent"
    @mouseenter="setCoordinatesFromMouseEvent"
    @mouseleave="clearCoordinates"
  >
    <BallPosition
      v-if="coordinates"
      :coordinates
      :ballSrc
    />
  </div>
</template>
